import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { SupportedLanguages } from '@/config/i18n'
import { LocalizedString } from '@/ducks/common.schema'

export const useServerTranslation = () => {
  const { i18n } = useTranslation()
  const language = (i18n.resolvedLanguage || 'en') as SupportedLanguages

  const getTranslation = useCallback(
    (translations: LocalizedString) =>
      translations[language] || translations['en'],
    [language]
  )

  return { language, getTranslation }
}
